import { useLayoutEffect as o, useEffect as t } from "react";
import { isBrowser as e } from "../utils/is-browser.js";
const s = e() ? o : t;
export {
  s as useIsomorphicLayoutEffect
};
//# sourceMappingURL=use-isomorphic-layout-effect.js.map
